import styled from 'styled-components';

export const HeaderTitleStyle = styled.div`
  display: flex;
  align-items: center;
  border-bottom: ${({ theme }) => {
    return theme.border;
  }};
  padding-bottom: 10px;
  img {
    width: 40px;
    margin-right: 25px;
  }

  h2 {
    margin: 0;
    color: ${({ theme }) => {
      return theme.colors.primary;
    }};
    font-size: ${({ theme }) => {
      return theme.fonts.size.superBig;
    }};
    font-weight: ${({ theme }) => {
      return theme.fonts.weight.thin;
    }};
  }
  a {
    margin-left: 20px;
    img {
      width: 120px;
    }
  }
`;
